import { useState } from 'react';
import { useCart } from '../context/CartContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import T from '../components/i18n/T';
import {
  AlertTriangle,
  ArrowRight,
  ShieldCheck,
} from 'lucide-react';
import { buildOfficialCheckoutHandoffUrl } from '../lib/officialCheckoutHandoff';

export default function Checkout() {
  const { cart } = useCart();
  const [error, setError] = useState('');

  const cartItems = Array.isArray(cart)
    ? cart
    : [];

  const continueToForfeo = async () => {
    setError('');

    try {
      window.location.assign(
        await buildOfficialCheckoutHandoffUrl(cartItems),
      );
    } catch (checkoutError) {
      setError(
        checkoutError instanceof Error
          ? checkoutError.message
          : 'Le transfert sécurisé du panier a échoué.',
      );
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Header />

      <main className="flex-1 px-4 pb-20 pt-32">
        <section className="mx-auto max-w-3xl overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl">
          <header className="bg-slate-950 px-7 py-10 text-white sm:px-10">
            <p className="text-xs font-black uppercase tracking-[0.24em] text-blue-300">
              Paiement officiel · Official checkout
            </p>

            <h1 className="mt-4 text-3xl font-black sm:text-4xl">
              <T
                fr="Continuer sur Forfeo.com"
                en="Continue on Forfeo.com"
              />
            </h1>

            <p className="mt-4 text-sm leading-7 text-slate-300">
              <T
                fr="Forfeo.com validera le prix, l’entreprise et la disponibilité directement dans ses catalogues officiels."
                en="Forfeo.com will validate price, business and availability directly from its official catalogues."
              />
            </p>
          </header>

          <div className="space-y-6 px-7 py-9 sm:px-10">
            <div className="rounded-2xl border border-blue-100 bg-blue-50 p-5">
              <p className="font-black text-slate-950">
                {cartItems.length} article
                {cartItems.length > 1 ? 's' : ''}
              </p>

              <p className="mt-2 text-sm leading-6 text-slate-600">
                <T
                  fr="Aucun prix, marchand ou statut de paiement n’est transmis par Explore."
                  en="No price, merchant or payment status is transmitted by Explore."
                />
              </p>
            </div>

            {error ? (
              <div
                role="alert"
                className="flex gap-3 rounded-2xl border border-red-200 bg-red-50 p-4 text-sm font-bold text-red-700"
              >
                <AlertTriangle className="h-5 w-5 shrink-0" />
                <span>{error}</span>
              </div>
            ) : null}

            <button
              type="button"
              disabled={cartItems.length === 0}
              onClick={continueToForfeo}
              className="flex w-full items-center justify-center gap-3 rounded-2xl bg-blue-700 px-6 py-4 text-sm font-black uppercase tracking-widest text-white transition hover:bg-blue-800 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <T
                fr="Continuer sur Forfeo.com"
                en="Continue on Forfeo.com"
              />

              <ArrowRight className="h-5 w-5" />
            </button>

            <div className="flex items-center justify-center gap-2 text-xs font-bold text-emerald-700">
              <ShieldCheck className="h-4 w-4" />

              <T
                fr="Prix et disponibilité validés côté serveur"
                en="Price and availability validated server-side"
              />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
